import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SyncLoader from "react-spinners/SyncLoader";
import moment from 'moment'

import api from '../../../baseurl';
import css from '../clients/style.module.css';
import authHeader from '../../../components/setAuthToken';

function CouponCode() {

    const [loading, setLoading] = useState(true)
    const [data, setData] = useState("");
    const [errorText, setErrorText] = useState("");

    useEffect(() => {
        setErrorText("");
        setData("");

        axios.get(`${api.baseURL}/v1/admin/coupon-usage`, {
            headers: authHeader()
        }).then((response) => {
            if (response.data.status === true) {
                setData(response.data.data)
            } else {
                setErrorText(response.data.message);
            }
            setLoading(false)
        }).catch((error) => {
            setErrorText(error.message);
            setLoading(false)
        })
    }, [])

    return (
        loading ? <SyncLoader /> :
            <div>
                <div className={css.users}>
                    {errorText && <span >{errorText}</span>}
                    <table>
                        <thead>
                            <tr>
                                <th>No</th>
                                <th>Date</th>
                                <th>Car ID</th>
                                <th>Хайсан утга</th>
                                <th>Ашигласан код</th>
                                <th>Компани нэр</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                data.length ?
                                    data.map((val, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{moment(val.createDate).format('YYYY-MM-DD')}</td>
                                                <td>{val.carId}</td>
                                                <td>{val.modelNumber}</td>
                                                <td>{val.couponCode}</td>
                                                <td>{val.name}</td>
                                            </tr>
                                        )
                                    }) : <tr><td colSpan={4}><h3>Үр дүн олдсонгүй</h3></td></tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
    );
}

export default CouponCode;
